import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments';
import {
  QuestionModel,
  AnswersPayload,
  SuitabilityResponse
} from '@shared/interfaces/question.interface';
import { PortfolioApi, PortfolioApiResponse } from '@shared/interfaces/portfolio.interface';
import { SKIP_ERROR_MODAL_HEADER } from '@constants';

const URL_SURVEY = `${environment.apiPath}api/survey/${environment.version.onboarding}`;
const URL_SUITABILITY = `${environment.apiPath}api/suitability/${environment.version.onboarding}`;

@Injectable({ providedIn: 'root' })
export class QuestionsService {
  private readonly http = inject(HttpClient);

  private get headers(): HttpHeaders {
    return new HttpHeaders({
      'Country-Code': environment.countryCode,
      'Accept': 'application/json'
    }).delete('Content-Type');
  }

  getQuestions(): Observable<QuestionModel> {
    return this.http.post<QuestionModel>(
      `${URL_SURVEY}/surveys/forms/suitability`,
      null,
      { headers: this.headers }
    );
  }

  sendAnswers(surveyId: string, payload: AnswersPayload): Observable<QuestionModel> {
    const headers = this.headers.set('X-No-Encrypt', 'true');
    return this.http.post<QuestionModel>(
      `${URL_SURVEY}/surveys/${surveyId}/answers`,
      payload,
      { headers }
    );
  }

  getTestResult(surveyId: string): Observable<SuitabilityResponse> {
    return this.http.get<SuitabilityResponse>(
      `${URL_SUITABILITY}/test/${surveyId}`,
      { headers: this.headers }
    );
  }

  getPortfolios(riskMax: number, clientType: string, investmentAmount: number): Observable<PortfolioApiResponse> {
    const params = `active=true&risk_max=${riskMax}&client_type=${encodeURIComponent(clientType)}&investment_amount=${investmentAmount}`;
    const headers = this.headers.set(SKIP_ERROR_MODAL_HEADER, '1');
    return this.http.get<PortfolioApiResponse>(
      `${URL_SUITABILITY}/products/portfolios?${params}`,
      { headers }
    );
  }

  getPublicPortfolio(portfolioId: string, amount: number): Observable<PortfolioApi> {
    return this.http.get<PortfolioApi>(
      `${URL_SUITABILITY}/public/products/portfolios/${portfolioId}?amount=${amount}`,
      { headers: this.headers }
    );
  }
}
